var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form-input', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }],
    attrs: {
      "field": "code",
      "mask": "code",
      "label": "Введите sms-код",
      "autocomplete": "off"
    },
    scopedSlots: _vm._u([{
      key: "error",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.errorCode || props.error))]
      }
    }])
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf93285c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/crv/FormPhoneVerify.vue
// module id = 832
// module chunks = 0